import { Action, createReducer, on } from '@ngrx/store';
import * as actions from '../actions';
import { ILoadBulkImportEmployeesResponse } from '../models/bulk-import-employees.model';

export const getBulkImportEmployeesDataKey = 'getBulkImportEmployeesData';

export interface State {
  loadBulkImportEmployeesResponse: ILoadBulkImportEmployeesResponse[];
  loadBulkImportEmployeesFailure: any;
  loaded: boolean;
}

export const initialState: State = {
  loadBulkImportEmployeesResponse: undefined,
  loadBulkImportEmployeesFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,

  on(actions.loadBulkImportEmployeesSuccess, (state, action) => ({
    ...state,
    loadBulkImportEmployeesResponse: action.response,
    loaded: true
  })),

  on(actions.loadBulkImportEmployeesFailure, (state, action) => ({
    ...state,
    loadBulkImportEmployeesFailure: action.error
  }))
);

export const getBulkImportEmployees = (state: State) => state.loadBulkImportEmployeesResponse;
